var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import config from '@/config';
import { TaskStatus } from '@/modules/tasks/taskboard/kanban/constants';
import api from '@/shared/api';
import { useTaskTimerContext } from '@/shared/providers/TaskTimerProvider';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import cloneDeep from 'lodash-es/cloneDeep';
import { TaskQueryKey } from './queryKey';
var extractIndexes = function (previousTasks, taskToUpdate) {
    var taskIndex = previousTasks.findIndex(function (t) { return t.id === taskToUpdate.id; });
    var subTaskIndex = -1;
    if (taskIndex < 0) {
        // eslint-disable-next-line no-restricted-syntax
        for (var i = 0; i < previousTasks.length; i++) {
            subTaskIndex = previousTasks[i].children.findIndex(function (t) { return t.id === taskToUpdate.id; });
            if (subTaskIndex >= 0) {
                taskIndex = i;
                break;
            }
        }
    }
    return { taskIndex: taskIndex, subTaskIndex: subTaskIndex };
};
var mapPropertiesAfterStatusChange = function (source, target) {
    if (!source || !target)
        return;
    target.status = source.status;
    target.isBlocked = source.isBlocked;
    target.inapplicable = source.inapplicable;
    target.rejected = source.rejected;
    target.taskColor = source.taskColor;
};
export var useUpdateTaskStatus = function () {
    var intl = useIntl();
    var queryClient = useQueryClient();
    var startStopTimerAfterStatusChange = useTaskTimerContext().startStopTimerAfterStatusChange;
    var _a = useMutation(function (values) {
        return api.base
            .put("".concat(config.appUrls.tasks, "/api/plannedTasks/UpdateStatus"), values)
            .then(function (res) { return res.data; });
    }, {
        onMutate: function (taskToUpdate) { return __awaiter(void 0, void 0, void 0, function () {
            var previousTasks, updatedTasks, mainTask, subTaskToUpdate, _a, taskIndex, subTaskIndex, amountDone, amountTotal;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: 
                    // Cancel any outgoing refetches
                    // (so they don't overwrite our optimistic update)
                    return [4 /*yield*/, queryClient.cancelQueries({ queryKey: [TaskQueryKey.PlannedTasks] })];
                    case 1:
                        // Cancel any outgoing refetches
                        // (so they don't overwrite our optimistic update)
                        _d.sent();
                        previousTasks = queryClient.getQueryData([TaskQueryKey.PlannedTasks]);
                        updatedTasks = cloneDeep(previousTasks);
                        mainTask = null;
                        subTaskToUpdate = null;
                        _a = extractIndexes((_b = previousTasks === null || previousTasks === void 0 ? void 0 : previousTasks.pages) === null || _b === void 0 ? void 0 : _b.flat(1), taskToUpdate), taskIndex = _a.taskIndex, subTaskIndex = _a.subTaskIndex;
                        if (taskIndex >= 0) {
                            mainTask = (_c = updatedTasks.pages) === null || _c === void 0 ? void 0 : _c.flat(1)[taskIndex];
                            if (subTaskIndex >= 0) {
                                subTaskToUpdate = mainTask.children[subTaskIndex];
                                subTaskToUpdate.status = taskToUpdate.status;
                                if (subTaskToUpdate.status === TaskStatus.Done) {
                                    subTaskToUpdate.taskColor = 0;
                                }
                                amountDone = mainTask.children.filter(function (f) { return f.status === TaskStatus.Done; }).length;
                                amountTotal = mainTask.children.length;
                                if (amountDone === amountTotal) {
                                    mainTask.status = TaskStatus.Done;
                                    mainTask.taskColor = 0;
                                }
                            }
                            else {
                                mainTask.status = taskToUpdate.status;
                                if (mainTask.status === TaskStatus.Done) {
                                    mainTask.taskColor = 0;
                                    mainTask.children = mainTask.children.map(function (m) { return (__assign(__assign({}, m), { status: TaskStatus.Done, taskColor: 0 })); });
                                }
                            }
                        }
                        // Optimistically update to the new value
                        queryClient.setQueryData([TaskQueryKey.PlannedTasks], updatedTasks);
                        // Return a context with the previous and updated tasks
                        return [2 /*return*/, {
                                previousTasks: previousTasks,
                                updatedTasks: updatedTasks,
                                task: subTaskToUpdate !== null && subTaskToUpdate !== void 0 ? subTaskToUpdate : mainTask,
                            }];
                }
            });
        }); },
        onSuccess: function (data, taskToUpdate, context) { return __awaiter(void 0, void 0, void 0, function () {
            var previousTasks, updatedTasksQueryData, previousMainTasks, updatedMainTask, previousMainTask, children_1, updatedSubtasks, task;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        previousTasks = context.previousTasks;
                        updatedTasksQueryData = __assign({}, previousTasks);
                        previousMainTasks = (_a = updatedTasksQueryData === null || updatedTasksQueryData === void 0 ? void 0 : updatedTasksQueryData.pages) === null || _a === void 0 ? void 0 : _a.flat(1);
                        updatedMainTask = data.find(function (x) { return x.id && !x.parentId; });
                        previousMainTask = previousMainTasks.find(function (x) { return x.id === (updatedMainTask === null || updatedMainTask === void 0 ? void 0 : updatedMainTask.id); });
                        if (previousMainTask) {
                            children_1 = previousMainTask.children;
                            mapPropertiesAfterStatusChange(updatedMainTask, previousMainTask);
                            updatedSubtasks = data.filter(function (x) { return x.id && x.parentId === (updatedMainTask === null || updatedMainTask === void 0 ? void 0 : updatedMainTask.id); });
                            if (updatedSubtasks.length && children_1.length) {
                                updatedSubtasks.forEach(function (updatedSubtask) {
                                    var previousSubtask = children_1.find(function (x) { return x.id === updatedSubtask.id; });
                                    mapPropertiesAfterStatusChange(updatedSubtask, previousSubtask);
                                });
                            }
                            previousMainTask.children = __spreadArray([], children_1, true); // useEffect in KanbanBoard.tsx is not called without this line, and we need it to trigger the reshuffling of columns
                        }
                        queryClient.setQueryData([TaskQueryKey.PlannedTasks], updatedTasksQueryData);
                        queryClient.invalidateQueries([TaskQueryKey.KPI]);
                        task = context.task;
                        if (!task) return [3 /*break*/, 2];
                        return [4 /*yield*/, startStopTimerAfterStatusChange(task)];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); },
        // If the mutation fails,
        // use the context returned from onMutate to roll back
        onError: function (err, taskToUpdate, context) {
            queryClient.setQueryData([TaskQueryKey.PlannedTasks], context.previousTasks);
            handleHttpError(intl)(err);
        },
    }), mutateAsync = _a.mutateAsync, isLoading = _a.isLoading, error = _a.error;
    return {
        updateTaskStatus: mutateAsync,
        isLoading: isLoading,
        error: error,
    };
};
